var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#0076B2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19532_94398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6299 13.8586C11.6299 13.3199 11.8184 12.8754 12.1954 12.5253C12.5725 12.1751 13.0627 12 13.6659 12C14.2584 12 14.7378 12.1724 15.1041 12.5172C15.4811 12.8727 15.6696 13.336 15.6696 13.9071C15.6696 14.4242 15.4865 14.8552 15.1202 15.2C14.7432 15.5556 14.2476 15.7333 13.6336 15.7333H13.6174C13.0249 15.7333 12.5456 15.5556 12.1793 15.2C11.813 14.8444 11.6299 14.3973 11.6299 13.8586ZM11.84 28V17.204H15.4273V28H11.84ZM17.4148 28H21.0021V21.9717C21.0021 21.5946 21.0452 21.3037 21.1314 21.099C21.2822 20.7326 21.5111 20.4229 21.8181 20.1697C22.1252 19.9165 22.5103 19.7899 22.9735 19.7899C24.1801 19.7899 24.7833 20.6033 24.7833 22.2303V28H28.3706V21.8101C28.3706 20.2155 27.9936 19.006 27.2395 18.1818C26.4854 17.3576 25.4889 16.9454 24.2501 16.9454C22.8604 16.9454 21.7777 17.5434 21.0021 18.7394V18.7717H20.986L21.0021 18.7394V17.204H17.4148C17.4364 17.5488 17.4471 18.6209 17.4471 20.4202C17.4471 22.2195 17.4364 24.7461 17.4148 28Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19532_94398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.7407,
    height: 16,
    fill: "white",
    transform: "translate(11.6299 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/LinkedInIcon.18c682e994bdcf3b1ffe1317e58325e6.svg";
export { ForwardRef as ReactComponent };